export default __webpack_public_path__ + "static/media/cognyte-logo.ed346870.svg";